import { withInstall } from '@chenms-zj/utils/with-install'
import _Switch from './src/switchs.vue'

export const Switchs = withInstall(_Switch)
export default Switchs

export * from './src/switchs'

// 声明模块
declare module 'vue' {
  export interface GlobalComponents {
    'cms-switchs': typeof Switchs
  }
}